import React, { useState, useEffect } from 'react';
import './BtnMembership.scss'
import { Link } from "react-router-dom";

const BtnSwitch = ({textBtn, linkTo}) => {
    return ( 
        <Link to={linkTo} className={`ButtonSwicth avtive-btn`}>
                <div className='center-container'>
                        <p className='text-btn'>
                            {textBtn}
                    </p>
                </div>
            </Link>


     );
}
 
export default BtnSwitch;



